import { faker } from '@faker-js/faker'

import { TargetLanguage } from '../../contracts/service-offer'
import { AdminUnitPropertyRequest } from '../../contracts/treatment/AdminUnitPropertyRequest'
import { asBuilder } from '../asBuilder'

export const getAdminUnitPropertyRequest = asBuilder((): AdminUnitPropertyRequest => {
  const names = faker.helpers.multiple(
    () => ({
      language: faker.helpers.enumValue(TargetLanguage),
      value: faker.lorem.word(),
    }),
    { count: 3 },
  )

  return {
    names,
    comparisonBaseValue: faker.number.int(),
  }
})
